import { NOM_COOKIE_ATK_CTX_ACCESD, WindowService } from "../window/window-service";

export class SjtiService {

    private static getCookieJson(): any {
        const valeurCookie = WindowService.getCookie(NOM_COOKIE_ATK_CTX_ACCESD);
        return valeurCookie ? JSON.parse(WindowService.nativeWindow().atob(valeurCookie)) : null;
    }

    public static obtenirSjti(): string | null | undefined {
        return this.getCookieJson()?.sjti;
    }

    public static estProspect(): boolean {
        return this.getCookieJson()?.prospect === true;
    }

}
